<template>
  <div class="modal-overflow">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Name</label>
          <el-input type="text"
                    name="name"
                    placeholder="Name"
                    ref="name"
                    clearable
                    :disabled="!canEditStreetName"
                    v-validate="modelValidations.name"
                    v-model="edit.name" />
          <small class="text-danger" v-show="errors.has('name')">
            {{ getError('name') }}
          </small>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <h6 style="padding-top:18px">Cities</h6>
          <div style="margin-top:18px;">
            <el-autocomplete
              style="width:100%"
              name="city"
              ref="city"
              data-vv-as="city"
              v-validate.continues="'atLeastOneCity'"
              data-vv-validate-on="blur"
              :disabled="!canEdit"
              class="inline-input"
              clearable
              v-model="localCity"
              :fetch-suggestions="findCities"
              :trigger-on-focus="false"
              value-key="name"
              @focus="resetValidator"
              @blur="verifyCitySelected"
              placeholder="City Search"
              @select="addCity">
            </el-autocomplete>
            <small class="text-danger" v-show="errors.has('city')">
              {{ getError('city') }}
            </small>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <table class="table-city-data wrap-whole-words">
          <colgroup>
            <col>
            <col style="width:45px">
          </colgroup>
          <tr v-for="city in edit.cities">
            <td class="grey-font">{{ city }}</td>
            <td>
              <p-button type="danger" size="sm" v-if="canEdit" icon @click="deleteCity(city)">
                <i class="fa fa-times"></i>
              </p-button>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="row" style="margin-top: 15px">
      <div class="col-md-12">
        <button type="button" :disabled="isProcessing" @click="validateAndSubmit" v-if="canEdit" class="btn btn-fill btn-info btn-wd pull-right">Save</button>
        <div class="form-group form-group-active-label">
          <label class="active-label">Active</label>
          <p-switch v-model="edit.active" type="primary" on-text="YES" off-text="NO"></p-switch>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    autocompleteReady,
    notifyError,
    saveStreet,
    verifyAutocompleteSelectedAndListPopulated
  } from 'src/utilities/utils'
  import Constants from 'src/utilities/constants'
  import Permissions from 'src/utilities/permissions'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import PButton from 'src/components/UIComponents/Button.vue'
  import {sync} from 'vuex-pathify'
  import {OK} from 'http-status-codes'

  export default {
    props: ['data'],
    components: {
      PButton,
      PSwitch
    },
    computed: {
      edit: sync('streets@edit'),
      canEdit() {
        return this.$can('edit', Permissions.STREETS)
      },
      canEditStreetName() {
        if (this.$store.get('security/isInGroup', Constants.GROUPS.SUPER_USERS)) {
          return true
        }
        if (this.$store.get('streets@edit.id') === null) {
          return this.$can('edit', Permissions.STREETS)
        }
      }
    },
    data() {
      return {
        constants: Constants,
        localCity: null,
        streetSaved: false,
        isProcessing: false,
        modelValidations: {
          name: {
            required: true,
            max: 64
          }
        }
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      resetValidator() {
        this.$validator.reset()
      },
      async validateAndSubmit() {
        this.isProcessing = true

        if (await this.$validator.validateAll()) {
          await saveStreet(this)
        }
        this.isProcessing = false
      },
      async findCities(text, cb) {
        if (autocompleteReady(text)) {
          const response = await this.$store.dispatch('address/cityStartsWith', text)
          if (OK === response.status && response.data.length > 0) {
            cb(response.data)
          }
        }
      },
      addCity(city) {
        if (city) {
          this.$store.commit('streets/addCity', city.name)
          this.localCity = ''
        }
      },
      deleteCity(city) {
        this.$store.commit('streets/deleteCity', city)
      },
      verifyCitySelected() {
        verifyAutocompleteSelectedAndListPopulated(
          this,
          'streets/edit',
          'city',
          'localCity',
          'cities')
      },
      validateAtLeastOneCity() {
        const self = this
        if (!Array.isArray(this.edit.cities)) {
          this.edit.cities = []
        }
        this.$validator.extend('atLeastOneCity', {
          getMessage() {
            return 'At least one city is required'
          },
          validate() {
            return self.edit.cities.length > 0
          }
        })
      }
    },
    async beforeMount() {
      this.validateAtLeastOneCity()
      if (this.data && this.data.id) {
        this.$store.commit('streets/resetEdit')
        const response = await this.$store.dispatch('fetchById', {
          endpoint: Constants.ENTITY_ENDPOINTS.STREETS,
          id: this.data.id
        })

        if (OK !== response.status) {
          notifyError(this, 'Failed to load street')
          return
        }

        this.$store.commit('streets/hydrateEdit', JSON.parse(JSON.stringify(response.data)))
      }
    },
    mounted() {
      this.$refs.name.focus()
    },
    destroyed() {
      if (!this.streetSaved) {
        this.$eventHub.$emit('noStreetSaved')
      }
    },
    watch: {
      localCity: {
        handler: function (localCity) {
          if (!localCity) {
            this.$validator.reset()
          }
        }
      }
    }
  }
</script>

<style scoped>
  label {
    display: block;
  }
  .table-city-data {
    width: 100%;
    margin-bottom: 12px;
    border: 1px solid #d3dce6;
  }
  .table-city-data tr {
    border-bottom: 1px solid #d3dce6;
  }
  .table-city-data tr td:first-child {
    padding: 3px 12px;
  }
</style>
